const PaymentMode = Object.freeze({
  CASH: 'CAS',
  CARD: 'CAR',
  BANK: 'BAN',
  CHECK: 'CHE',
  CAUTION_CHECK: 'CAU',
  INSURANCE: 'INS',
  CREDIT_NOTE: 'CRN',
  ELECTRONIQUE: 'ELE',
  LEVY: 'LEV',
  HEALTH_MUTUAL: 'MUT',
  OTHER: 'OTH',
  DISCREPENCY: 'DIS'
})

export default PaymentMode
